import { render, staticRenderFns } from "./button-disable-account.vue?vue&type=template&id=5a7c5f4e&"
import script from "./button-disable-account.vue?vue&type=script&lang=js&"
export * from "./button-disable-account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports